import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-services',
  templateUrl: './main-services.component.html',
  styleUrls: ['./main-services.component.css'],
})
export class MainServicesComponent implements OnInit {
  public useWhiteLogo: boolean;
  public isSmartPhone: boolean;

  currentSection = 'home';

  constructor(public breakpointObserver: BreakpointObserver) {}

  ngOnInit(): void {
    this.useWhiteLogo = true;
    this.isSmartPhone = false;

    this.breakpointObserver
      .observe(['(max-width: 768px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.useWhiteLogo = false;
          this.isSmartPhone = true;
        } else {
          this.isSmartPhone = false;
        }
      });
  }

  /**
   * Window scroll method
   */
  windowScroll() {
    const navbar = document.getElementById('navbar');
    if (
      document.body.scrollTop >= 50 ||
      document.documentElement.scrollTop > 50
    ) {
      navbar.classList.add('nav-sticky');
      this.useWhiteLogo = false;
    } else {
      navbar.classList.remove('nav-sticky');
      this.useWhiteLogo = true;
    }
  }

  /**
   * Section changed method
   * @param sectionId specify the current sectionID
   */
  onSectionChange(sectionId: string) {
    this.currentSection = sectionId;
  }

  /**
   * Toggle navbar
   */
  toggleMenu() {
    document.getElementById('navbarCollapse').classList.toggle('show');
  }
}
